export type EpubPageTrackerState = {
  pageNumber: string;
};

export const initialEpubPageTrackerState: EpubPageTrackerState = {
  pageNumber: "",
};
